export const preventDefault = (event: Event) => {
  event.preventDefault();
};

export const stopPropagation = (event: Event) => {
  event.stopPropagation();
};
